import { OrderStatus } from '@core/models';

export const WORK_ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  RECEIVED: 'Recibida',
  PRE_REVIEW: 'Pre revisión',
  QUOTED: 'Cotizada',
  APPROVED: 'Aprobada',
  IN_PROGRESS: 'En proceso',
  // WASHING: 'Lavado',
  COMPLETED: 'Completada',
  CLOSED: 'Cerrada',
  CANCELLED: 'Cancelada',
} as const;

export const WORK_ORDERS_STATUS: Record<OrderStatus, OrderStatus> = {
  RECEIVED: 'RECEIVED',
  PRE_REVIEW: 'PRE_REVIEW',
  QUOTED: 'QUOTED',
  APPROVED: 'APPROVED',
  IN_PROGRESS: 'IN_PROGRESS',
  // WASHING: 'WASHING',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
} as const;

